import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const uscgCompatibilityHardRule = {
    id: StowageRuleId.UscgCompatibilityHardRule,
    name: 'Adjacent cargoes must be compatible as defined in the USCG compatibility map.',
    lastUpdatedUtc: '2014-05-15T13:24:00',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Are tank contents USCG compatible',
                            fieldPath: 'areTankContentsUscgCompatible',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.AdjacentTank,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'false',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.AnyAdjacentTanks,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Incompatible USCG cargoes.',
    },
} as StowageRuleBM;
